import type { MarketView, Runner } from '@ps/isp-web-services-types';
import React from 'react';

import { Selection } from '@swf/sports/components';
import getParticipantAndScoresFromRunnerName from '@swf/sports/utils/getParticipantAndScoresFromRunnerName';

import styles from './SelectionTable.scss';

export interface Props {
  header: string[];
  rows: (Runner | undefined)[][];
  isScoreVisible?: boolean;
  market: MarketView;
  testId?: string;
  eventStartTime: string;
  allOtherScoresRunner?: Runner;
  hasLimitedRows?: boolean;
}

const Table = ({
  header,
  rows,
  market,
  isScoreVisible = false,
  testId,
  eventStartTime,
  allOtherScoresRunner,
  hasLimitedRows
}: Props) => {
  const shouldShowAllOtherScoresRunner = allOtherScoresRunner && !hasLimitedRows;

  return (
    <table data-testid={testId} className={styles.table}>
      <thead>
        <tr>
          {header.map((header) => (
            <th scope="col" key={`header-${market.marketId}-${header}`}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody
        className={
          shouldShowAllOtherScoresRunner ? styles.tableBodyAllOtherScore : styles.tableBody
        }
      >
        {rows.map((row, i) => (
          <tr key={`row-${market.marketId}-${i}`}>
            {row.map((runner, j) => {
              const { homeScore, awayScore } = getParticipantAndScoresFromRunnerName(
                runner?.runnerName ?? ''
              );
              return (
                <td key={runner ? runner.selectionId : `cell-${market.marketId}-${i}-${j}`}>
                  {runner && (
                    <Selection
                      competitionId={market.competitionId}
                      eventId={market.eventId}
                      eventTypeId={market.eventTypeId}
                      handicap={runner.handicap}
                      legTypes={market.legTypes}
                      marketId={market.marketId}
                      marketStatus={market.marketStatus}
                      marketType={market.marketType}
                      odds={runner.winRunnerOdds}
                      runnerResultType={runner.resultType}
                      runnerStatus={runner.runnerStatus}
                      selectionId={runner.selectionId}
                      selectionText={isScoreVisible ? `${homeScore}-${awayScore}` : undefined}
                      startTime={eventStartTime}
                    />
                  )}
                </td>
              );
            })}
          </tr>
        ))}
        {shouldShowAllOtherScoresRunner ? (
          <tr className={styles.allOtherScoreRow}>
            <td className={styles.allOtherScoreRunner}>{allOtherScoresRunner.runnerName}</td>
            <td>
              <Selection
                competitionId={market.competitionId}
                eventId={market.eventId}
                eventTypeId={market.eventTypeId}
                handicap={allOtherScoresRunner.handicap}
                legTypes={market.legTypes}
                marketId={market.marketId}
                marketStatus={market.marketStatus}
                marketType={market.marketType}
                odds={allOtherScoresRunner.winRunnerOdds}
                runnerResultType={allOtherScoresRunner.resultType}
                runnerStatus={allOtherScoresRunner.runnerStatus}
                selectionId={allOtherScoresRunner.selectionId}
                startTime={eventStartTime}
              />
            </td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
};

export default Table;
